const showPharmacyHours = function () {
    $('.scheduled-store').hide();
    $('.scheduled-pharmacy').fadeIn();
}

const showRegularHours = function () {
    $('.scheduled-pharmacy').hide();
    $('.scheduled-store').fadeIn();
}

const showRegularHoursGroup = function () {
    $('#special-schedule-during-special-week').hide();
    $('#regular-schedule-during-special-week').fadeIn();
}

const showSpecialHoursGroup = function () {
    $('#regular-schedule-during-special-week').hide();
    $('#special-schedule-during-special-week').fadeIn();
}

$(document).ready(function () {
    let $hoursTabs = $('.hoursTabs .tab');
    $hoursTabs.on('click', function() {
        if (!$(this).hasClass('is_active')) {
            $hoursTabs.toggleClass('is_active');
        }
    })
});